<template>
  <AppLazySelect
    ref="dropdown"
    class="project-filter"
    data-testid="time-entries-project-filter"
    :label="labelText"
    :fetcher="fetcher"
    resource="project"
    :resource-label="resourceLabel"
    :resource-label-plural="resourceLabelPlural"
    as-filter
    multiple
    eager
    preload
    :value="selectedIds"
    @input="onSelectItems"
  >
    <template #placeholder>All {{ resourceLabelPlural.toLowerCase() }}</template>
  </AppLazySelect>
</template>

<script>
import { mapGetters } from 'vuex';
import { getProjectFlavourLabel } from '~/utils/project_flavour';
import { TimeEntriesResource } from '~/resources';
import { debounce } from 'lodash-es';

export default {
  name: 'TimeEntriesProjectFilter',
  computed: {
    ...mapGetters(['projects', 'projectFlavour', 'organizationId', 'timeEntriesQuery']),
    labelText() {
      return getProjectFlavourLabel(this.projectFlavour);
    },
    resourceLabel() {
      // Singular base label for the selector (e.g. "Project", "Work order", or "Project / Work order")
      return getProjectFlavourLabel(this.projectFlavour, false);
    },
    resourceLabelPlural() {
      // plural label, e.g. "Projects", "Work orders", or "Projects / Work orders"
      return getProjectFlavourLabel(this.projectFlavour, true);
    },
    selectedIds() {
      return {
        items: (this.timeEntriesQuery.filters.project_ids || []).map((id) => parseInt(id)),
        selectAll: (this.timeEntriesQuery.filters.select_all_projects || 'true') === 'true',
      };
    },
  },
  created() {
    this.$store.subscribeAction((action) => {
      if (action.type === 'clearFilters') {
        this.$refs.dropdown.onClearAll();
      }
    });
  },
  methods: {
    fetcher(payload) {
      return TimeEntriesResource.projects(
        { organization_id: this.organizationId },
        {
          ...payload,
          prefix_ids: false,
          as_filter: true,
        },
        {
          abortReload: true,
        },
      );
    },
    onSelectItems: debounce(function ({ items, selectAll }) {
      const data = {
        project_ids: items,
        select_all_projects: selectAll.toString(),
      };

      this.$store.dispatch('updateSearch', { filters: data });
      this.$emit('filter-change', data);
    }, 700),
  },
};
</script>
